import { Component, OnInit, OnDestroy } from '@angular/core';

@Component({
  selector: 'app-navbar-cart',
  templateUrl: './navbar-cart.component.html',
})
export class NavbarCartComponent implements OnInit, OnDestroy {
  countdownText: string = '';
  private countdownInterval: any;
  private targetTime: Date;

  constructor() {}

  async ngOnInit() {
    const loginTime = localStorage.getItem('turkakLoginTime');
    if (loginTime) {
      const loginDate = new Date(loginTime); // Login zamanını al
      this.targetTime = new Date(loginDate.getTime() + 12 * 60 * 60 * 1000); // 12 saat ekle
      this.startCountdown();
    }
  }

  startCountdown() {
    this.updateCountdown(); // İlk güncelleme

    // Gerçek zamanlı güncelleme için setInterval kullanıyoruz
    this.countdownInterval = setInterval(() => {
      this.updateCountdown();
    }, 1000); // Her saniye güncellenir
  }

  updateCountdown() {
    const currentTime = new Date();
    const timeDiff = this.targetTime.getTime() - currentTime.getTime(); // Zaman farkı (milisaniye)

    if (timeDiff <= 0) {
      clearInterval(this.countdownInterval); // Zaman bitince interval durdurulur
      this.countdownText = 'Zaman doldu';
      return;
    }

    // Eğer 12 saatin altına inmediyse, saat farkı
    if (timeDiff > 3600000 * 12) {
      const hoursRemaining = Math.floor(timeDiff / 3600000);
      this.countdownText = `${hoursRemaining} s kaldı`;
    }
    // 1 saate kadar dakika cinsinden geriye sayma
    else if (timeDiff <= 3600000) {
      const minutesRemaining = Math.floor(timeDiff / 60000);
      this.countdownText = `${minutesRemaining} dk kaldı`;
    }
    // 1 saatin üzerindeyse, saat cinsinden kalan zaman
    else {
      const hoursRemaining = Math.floor(timeDiff / 3600000);
      this.countdownText = `${hoursRemaining} s kaldı`;
    }
  }

  ngOnDestroy() {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval); // component destroy edildiğinde interval'i temizle
    }
  }
}
